// src/components/cloud/UploadZone.jsx
import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import './cloud.css';

const UploadZone = ({ onUpload }) => {
    const onDrop = useCallback((acceptedFiles) => {
        onUpload(acceptedFiles);
    }, [onUpload]);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

    return (
        <div {...getRootProps()} className={`upload-zone ${isDragActive ? 'active' : ''}`}>
            <input {...getInputProps()} />
            {isDragActive ? (
                <p>Rilascia i file qui...</p>
            ) : (
                <p>Trascina i file qui, o clicca per selezionarli</p>
            )}
        </div>
    );
};

export default UploadZone;